// extracted by mini-css-extract-plugin
module.exports = {"container":"clinical-portal-3__Support__container","profile":"clinical-portal-3__Support__profile","avatar":"clinical-portal-3__Support__avatar"};